import { render, staticRenderFns } from "./programUserPage.vue?vue&type=template&id=c4709000&scoped=true&"
import script from "./programUserPage.vue?vue&type=script&lang=js&"
export * from "./programUserPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4709000",
  null
  
)

export default component.exports